
import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import booleanops_subtract_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/booleanops_subtract.svg';
import { img } from '@phi/components';
import { execute_boolean_operation } from '@frontend/ui_display';
import BooleanOpsTooltip from './BooleanOpsTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const BooleanIcon = booleanops_subtract_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'BooleanOpsUnion';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator;
            //|| (
            //    clipping_on.value
            //    && !clipping_model_editable.value
            //)
            //|| this.state.selected_vertices_count === 0;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                execute_boolean_operation('Subtract');
        },
    },

    render() {
        return h(BarButton, {
            id: 'boolean-ops-union-button',
            wrapperId: 'boolean-ops-wrapper',
            tippy: 'left',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 5,
            disabled: this.disabled,
            help: 'boolean_ops',
        }, {
            label: () => 'Subtract',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(booleanops_subtract_svg, this.alt),
            tooltip: BooleanOpsTooltip,
        });
    },
});
